import { alertVariants } from "@visiblethread/react-components";
import errorHandler from "handlers/errorHandler";
import { showGlobalAlert } from "slices/app/appSlice";

export const VISI_REQUEST_CONFIG = { skipAuthRedirect: true };

const reportedByVisi = (payload) => Boolean(payload?.errorCode);

/**
 * Decides who owns a failed Visi request.
 *
 * The global handler treats every 401/403/405 as an expired session and navigates to the login
 * page, which would replace the whole app when Visi is merely switched off. A rejection Visi
 * itself produced carries an errorCode and belongs in the panel; anything else is a real auth
 * failure and is handed back to the global handler.
 */
export const delegateNonVisiError = (payload, status) => {
  if (reportedByVisi(payload)) {
    return;
  }
  try {
    errorHandler({ status, data: payload });
  } catch {
    // errorHandler starts the redirect and then throws axios.Cancel to stop the chain.
  }
};

export const showVisiRequestFailed = (dispatch, text) =>
  dispatch(showGlobalAlert({ variant: alertVariants.danger, text }));

export const delegateNonVisiAxiosError = (error) =>
  delegateNonVisiError(error?.response?.data, error?.response?.status);
